<template>
  <div>
    <div class="banner">
      <div class="headerReplacementFinancialInfo"></div>
      <div class="banner-text">
        <b>{{ $t('statements.pageTitle') }}</b>
        <div class="breadcrumb">
          <span>
            <router-link to="/" class="pe-auto">{{ $t('statements.breadcrumbHome') }}</router-link>
          </span>
          <span class="separator"></span>
          <span>{{ $t('statements.breadcrumbSection') }}</span>
          <span class="separator"></span>
          <span><b>{{ $t('statements.breadcrumbPage') }}</b></span>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="TabMenu">
        <FinancialInfoTabMenu />
      </div>

      <div class="row justify-content-center align-items-center mb-5">
        <div class="card card-pdf bg-white mt-5 mb-3">
          <div class="row">
            <div class="col-12 col-md-6 text-center bg-black">
              <img src="../../assets/banner/img-1.jpeg" class="img-fluid rounded-start p-3" style="max-height: 300px;">
            </div>
            <div class="col-md-6 d-flex">
              <div class="vertical-line"></div>
              <div class="card-body">
                <p class="card-text text-secondary">{{ $t('statements.financialLabel') }}</p>
                <h4 class="card-title mb-5">
                  <b>{{ $t('statements.quarterLabel') }} {{ latestDocument.quarter }} {{ $t('statements.year') || 'ปี' }} {{ latestDocument.year }}</b>
                </h4>
                <p class="card-text text-secondary">
                  <small class="text-muted">
                    <i class="fa-solid fa-download"></i>
                    <a :href="latestDocument.pdf_url" target="_blank" class="text-decoration-none">
                      {{ $t('statements.download') }}
                    </a>
                  </small>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- เลือกปี -->
      <div class="row g-3 row justify-content-end mb-3">
        <div class="col-auto">
          <label class="col-form-label">{{ $t('statements.selectYear') }}</label>
        </div>
        <div class="col-auto">
          <select id="yearSelect" v-model="selectedYear" class="form-select" aria-label="Year selection">
            <option value="2025">2025</option>
            <option value="2024">2024</option>
            <option value="2023">2023</option>
            <option value="2022">2022</option>
            <option value="2021">2021</option>
          </select>
        </div>
      </div>

      <!-- ตาราง -->
      <table class="table mb-5">
        <thead>
          <tr class="table-secondary">
            <th scope="col"><b>{{ selectedYear }}</b></th>
            <th scope="col" class="text-end"><b>{{ $t('statements.document') }}</b></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in filteredList" :key="index">
            <td>
              <p class="m-0">{{ $t('statements.financialLabel') }} {{ $t('statements.quarterLabel') }} {{ item.quarter }}</p>
            </td>
            <td class="text-end">
              <a :href="item.pdf_url" target="_blank" class="text-decoration-none">
                <p class="card-text text-secondary">
                  <small class="text-muted">
                    <i class="fa-solid fa-download"></i> {{ $t('statements.download') }}
                  </small>
                </p>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>


<script>
import FinancialInfoTabMenu from '@/components/FinancialInfoTabMenu.vue';
import store from "@/store";
import { GET_FINANCIAL_DATA } from "../../store/actions.type";

export default {
  name: 'Statements',
  components: {
    FinancialInfoTabMenu,
  },
  data() {
    return {
      selectedYear: '2025',
      list: [],
      latestDocument: {},
      isLoading: false
    };
  },
  async created() {
    this.isLoading = true;
    await this.init();
    this.isLoading = false;
  },
  watch: {
    '$i18n.locale'(newLang) {
      this.init();
    }
  },
  computed: {
    filteredList() {
      return this.list
        .filter(item => item.year.toString() === this.selectedYear)
        .sort((a, b) => a.year === b.year ? a.quarter - b.quarter : a.year - b.year);
    }
  },
  methods: {
    async init() {
      const lang = this.$i18n.locale || 'th';
      try {
        this.list = await store.dispatch(GET_FINANCIAL_DATA, lang);
        this.latestDocument = this.getLatestDocument();
      } catch (e) {
        console.error('Error loading financial data', e);
      }
    },
    getLatestDocument() {
      return this.list
        .sort((a, b) => a.year === b.year ? b.quarter - a.quarter : b.year - a.year)[0];
    }
  }
};

</script>

<style scoped>
.bg-body-docs {
  background-color: #F2F2F2;
}

h2.mt-5 {
  display: inline-block;
  border-bottom: 3px solid #E87D2E;
  padding-bottom: 5px;
}

.card-pdf {
  box-shadow: 0px 4px 10px 0px #0000000D;
  border: none;
  width: 800px;
}

.card {
  background-color: #F2F2F2;
}

.vertical-line {
  width: 4px;
  background-color: #E87D2E;
  height: 160px;
}

th {
  font-weight: normal;
}

.table {
  margin-bottom: 0;
}
</style>
